import React, { useState, useEffect, Fragment } from 'react';
import { Row } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import './css/property.scss';
import MessageResponse from './ResponseBlock/MessageResponse';
import LinkResponse from './ResponseBlock/LinkResponse';
import ImageCarouselResponse from './ResponseBlock/ImageCarouselResponse';
import VideoResponse from './ResponseBlock/VideoResponse';

import { RotateSpinner } from 'react-spinners-kit';

import ExampleResponse from './ResponseBlock/ExampleResponse';
import { postAPI_TrackEvent, gAPI_Favourite } from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';

function ResponseBlock({ getUrl, propertyId, locale, email }) {
  const [responseData, setResponseData] = useState(null);
  const [result, setResult] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [FavResult, setFavResult] = useState([]);


  const reloadBotResponse = async () => {
    setIsLoading(true);
    return await AxiosAPI({
      methed: 'get',
      url: `${getUrl}/?property_id=${propertyId}&group_id=${getGroupID()}&lang=${locale === 'en' ? 'en-US' : locale
        }`,
    })
      .then((res) => {
        setResult(res.data);
        AxiosAPI({
          methed: 'get',
          url: `${gAPI_Favourite}?property_id=${propertyId}&group_id=${getGroupID()}&lang=${locale === 'en' ? 'en-US' : locale
            }`,
        })
          .then((res) => {
            setFavResult(res.data);
            setIsLoading(false);
            //console.log('fav Bot Response', res.data);
          })
          .catch((err) => {
            console.log(err);
          });

        //console.log('All Bot Response', res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    reloadBotResponse();
    if (email !== '') {
      AxiosAPI({
        method: 'post',
        url: `${postAPI_TrackEvent}`,
        data: {
          eventName: 'Dashboard Knowledge Hub',
          email: email,
        },
      }).then(
        (res) => { },
        (error) => {
          console.log(error);
        }
      );
    }
  }, []);

  useEffect(() => {
    setResponseData(result);
  }, [result]);


  const generator = () => {
    if (responseData && FavResult) {
      return responseData.map((elem, index) => {
        const favarr = FavResult.filter(m => m.query.code === elem.query.code);
        let fav = false;
        if (favarr.length > 0) {
          fav = true;
        }
        switch (elem.response.type) {
          case 'example':
            return (
              <Fragment key={index}>
                <ExampleResponse
                  favouriteResponse={fav}
                  elem={{ ...elem }}
                  reloadBotResponse={reloadBotResponse}
                  showFav={true}
                />
              </Fragment>
            );

          case 'messages':

            return (
              <Fragment key={index}>
                <MessageResponse
                  favouriteResponse={fav}
                  elem={{ ...elem }}
                  reloadBotResponse={reloadBotResponse}
                  showFav={true}
                />
              </Fragment>
            );

          case 'messages-link':
            return (
              <Fragment key={index}>
                <LinkResponse
                  favouriteResponse={fav}
                  elem={{ ...elem }}
                  reloadBotResponse={reloadBotResponse}
                  showFav={true}
                />
              </Fragment>
            );

          case 'messages-image-carousel':
            return (
              <Fragment key={index}>
                <ImageCarouselResponse
                  favouriteResponse={fav}
                  elem={{ ...elem }}
                  reloadBotResponse={reloadBotResponse}
                  showFav={true}
                />
              </Fragment>
            );
          case 'messages-video':
            return (
              <Fragment key={index}>
                <VideoResponse
                  favouriteResponse={fav}
                  elem={{ ...elem }}
                  reloadBotResponse={reloadBotResponse}
                  showFav={true}
                />
              </Fragment>
            );
          default:
            break;
        }
      });
    } else return null;
  };


  return (
    <Fragment>
      {isLoading ? (
        <Row>
          <Colxx xxs="5" className="mb-2"></Colxx>
          <Colxx xxs="2" className="mb-2">
            <RotateSpinner size={60} color="#4556AC" loading={isLoading} />
          </Colxx>
          <Colxx xxs="5" className="mb-2"></Colxx>
        </Row>
      ) : (
        generator()
      )}
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, email } = settings;
  return {
    propertyId,
    locale,
    email,
  };
};

export default injectIntl(connect(mapStateToProps)(ResponseBlock));
